import Login from '../pages/auth/login.vue';
import Blog from '../pages/blog/blog.vue';
import Home from '../pages/home/home.vue';
import Post from '../pages/post/create-post.vue';
import ImportPost from '../pages/post/import_post.vue';
import ListPost from '../pages/post/list_post.vue';
import ListImports from '../pages/post/list_imports.vue';
import EditPost from '../pages/post/edit_post.vue';
import ListCategory from '../pages/category/list_category.vue';
import Theme from '../pages/theme/theme.vue';
import ThemeDefault from '../pages/theme/themeList/defaultTheme/theme_home.vue';
import ThemeSecond from '../pages/theme/themeList/secondTheme/theme_home.vue';
import ThemeThird from '../pages/theme/themeList/thirdTheme/theme_home.vue';
import General from '../pages/general/general.vue';
import i18n from '../plugins/i18n.js';
import BlogShare from '../pages/blog/share/index';
import PostShare from '../pages/post/share/index';

if ('localStorage' in window) {
  i18n.locale = localStorage.getItem('lang') || 'en';
}

export default [{
    path: '/',
    name: 'welcome',
    component: Blog,
    meta: {
      pageTitle: 'Blogs',
      rule: 'guest'
    }
  },
  {
    path: '/login',
    name: 'login',
    component: Login,
    meta: {
      pageTitle: 'Login',
      rule: 'guest'
    }
  },
  {
    path: '/blog',
    name: 'blog',
    component: Blog,
    meta: {
      pageTitle: 'Blogs',
      rule: 'guest'
    }
  },
  {
    path: '/publish',
    name: 'home',
    component: Home,
    meta: {
      pageTitle: i18n.t('frontend_publish'),
      rule: 'admin'
    }
  },
  {
    path: '/post/create',
    name: 'create_post',
    component: Post,
    meta: {
      pageTitle: i18n.t('frontend_grooveblog_write_new_post'),
      rule: 'admin'
    }
  },
  {
    path: '/post/import',
    name: 'import_post',
    component: ImportPost,
    meta: {
      pageTitle: i18n.t('frontend_grooveblog_import_new_post'),
      rule: 'admin'
    }
  },
  {
    path: '/post',
    name: 'list_post',
    component: ListPost,
    meta: {
      pageTitle: 'Posts',
      rule: 'admin'
    }
  },
  {
    path: '/imports',
    name: 'list_imports',
    component: ListImports,
    meta: {
      pageTitle: 'Imports',
      rule: 'admin'
    }
  },
  {
    path: '/post/:postId',
    name: 'edit_post',
    component: EditPost,
    meta: {
      pageTitle: i18n.t('frontend_grooveblog_edit_post'),
      rule: 'admin'
    }
  },
  {
    path: '/categories',
    name: 'list_category',
    component: ListCategory,
    meta: {
      pageTitle: i18n.t('frontend_grooveblog_categories'),
      rule: 'admin'
    }
  },
  {
    path: '/theme',
    name: 'theme',
    component: Theme,
    meta: {
      pageTitle: i18n.t('frontend_grooveblog_theme'),
      rule: 'admin'
    }
  },
  {
    path: '/theme_default',
    name: 'theme_default',
    component: ThemeDefault,
    meta: {
      pageTitle: i18n.t('frontend_grooveblog_customize_theme'),
      rule: 'admin'
    }
  },
  {
    path: '/theme_second',
    name: 'theme_second',
    component: ThemeSecond,
    meta: {
      pageTitle: i18n.t('frontend_grooveblog_customize_theme'),
      rule: 'admin'
    }
  },
  {
    path: '/theme_third',
    name: 'theme_third',
    component: ThemeThird,
    meta: {
      pageTitle: i18n.t('frontend_grooveblog_customize_theme'),
      rule: 'admin'
    }
  },
  {
    path: '/settings',
    name: 'general',
    component: General,
    meta: {
      pageTitle: i18n.t('frontend_settings'),
      rule: 'admin'
    }
  },
  {
    path: '/blogs/:id/share',
    name: 'blog_share',
    component: BlogShare,
    meta: {
        pageTitle: ' ',
        rule: 'admin'
    }
},
{
  path: '/post/:id/share',
  name: 'post_share',
  component: PostShare,
  meta: {
      pageTitle: ' ',
      rule: 'admin'
  }
},
];
